import { createContext } from "react";
import {
  User,
  UserGroup,
  UserGroupMembersIdsMap,
  UserGroupWithUserIds,
  NameToIdAndTypeMap,
} from "../apiHooks/users/user.types";

type UsersAndGroupsContext = {
  isLoadingUsers: boolean;
  isLoadingUserGroups: boolean;
  users: User[];
  activeUsers: User[];
  usersMap: Record<string, User | undefined>;
  groups: UserGroup[];
  groupsMap: Record<string, UserGroup | undefined>;
  groupWithMembers: UserGroupWithUserIds[];
  groupMembersMap: UserGroupMembersIdsMap;
  nameToIdAndTypeMap: NameToIdAndTypeMap;
  idToNameMap: Record<string, string>;
};

export const UsersAndGroupsContext = createContext<UsersAndGroupsContext | undefined>(undefined);
